import React from "react";
import { Image as KonvaImage } from "react-konva";
import useImage from "./useImage";

export default function MyImage(props) {
  const [image, loading, error] = useImage(props.src);
  const isGif = props.src && props.src.toLowerCase().endsWith('.gif');
  
  if (loading) {
    // عرض مؤشر تحميل
    return (
      <KonvaImage
        {...props}
        image={null}
        fill="#f0f0f0"
        stroke="#ddd"
        strokeWidth={1}
        dash={[5, 5]}
      />
    );
  }
  
  if (error || !image) {
    // عرض رسالة خطأ
    return (
      <KonvaImage
        {...props}
        image={null}
        fill="#ffebee"
        stroke="#f44336"
        strokeWidth={2}
      />
    );
  }
  
  // معالجة خاصة لملفات GIF
  if (isGif) {
    return (
      <KonvaImage 
        image={image} 
        {...props}
        // تحسينات خاصة لملفات GIF
        perfectDrawEnabled={false}
        listening={true}
      />
    );
  }
  
  return <KonvaImage image={image} {...props} />;
}
